import { store } from "@customer-app/state/store";

export const getStoreValidation = () => {
  return store.getState().auth.validation;
};
